/**
 * ExcludeSpecialCharacters
 *
 * Regular expression that matches any character not in the printable ASCII range (space through tilde) or newline.
 * Intended to sanitize input by removing non-printable and non-ASCII characters, except for line breaks.
 * (example: emojis, chinese characters, etc.)
 *
 * @usage
 * ```ts
 * const sanitized = input.replace(ExcludeSpecialCharacters, '');
 * ```
 */
export const ExcludeSpecialCharacters = /[^ -~\n]/g;
